import { CancelablePromise, apiRequest, setCookieRequest } from '../../../main/services/api'
import { ActionTypes } from '../constants/constants'
import AppDispatcher from '../dispatcher/appDispatcher'
import RowsStore from '../stores/rowsStore'
import { FuturesDatum } from '../types'
import { getCookie } from '../utils'

var cookieKey = 'finvizFuturesQuotesTimeframe'

var getFuturesUrl = function () {
  var timeframe = RowsStore.getTimeframe()
  return '/api/futures_all.ashx?timeframe=' + timeframe
}

function migrateOldTimeframe(timeframe: string) {
  switch (timeframe) {
    case 'm5':
      return 'i5'
    case 'h1':
      return 'h'
    case 'd1':
      return 'd'
    case 'w1':
      return 'w'
    case 'm1':
      return 'm'
  }

  return timeframe
}

let _lastRequest: CancelablePromise<any> | null = null

const actions = {
  init(rows: FuturesDatum[], type?: any) {
    var timeframe
    if (type === 'quotes') {
      timeframe = migrateOldTimeframe(getCookie(cookieKey)) || 'NO'
    }
    AppDispatcher.handleViewAction({
      type: ActionTypes.INIT,
      rows,
      timeframe,
    })
  },

  async update(data: FuturesDatum[]) {
    if (data) {
      AppDispatcher.handleViewAction({
        type: ActionTypes.UPDATE_DATA,
        tiles: data,
      })
      return
    }

    _lastRequest?.cancel?.()
    _lastRequest = apiRequest(getFuturesUrl())
    const resData = await _lastRequest
    if (resData) {
      AppDispatcher.handleServerAction({
        type: ActionTypes.UPDATE_DATA,
        tiles: resData,
      })
    }
  },

  async changeTimeframe(timeframe: string, updateCookie = true) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.CHANGE_TIMEFRAME_STARTED,
      period: timeframe,
    })

    _lastRequest?.cancel?.()
    _lastRequest = apiRequest(getFuturesUrl())
    const data = await _lastRequest
    if (data) {
      AppDispatcher.handleServerAction({
        type: ActionTypes.UPDATE_DATA,
        tiles: data,
      })
      AppDispatcher.handleServerAction({
        type: ActionTypes.CHANGE_TIMEFRAME_COMPLETED,
      })
    }
    if (updateCookie) setCookieRequest(cookieKey, timeframe).catch(() => {})
  },
}

export default actions
